import React, {Fragment, useEffect, useState} from 'react'
import {Disclosure, RadioGroup, Tab, Menu, Transition} from '@headlessui/react'
import {
    BellIcon, StarIcon, FolderOpenIcon, PencilSquareIcon, CheckIcon, ChevronRightIcon, MagnifyingGlassIcon
} from '@heroicons/react/20/solid'
import {HeartIcon, MinusIcon, PlusIcon, XMarkIcon, Bars3Icon} from '@heroicons/react/24/outline'
import {findVenue} from "../../components/search/VenueSearch";
import axios from "axios";
import {Link, useLoaderData, useLocation} from "react-router-dom";
import PropertyNavigation from "../../components/common/navigation.component";
import {
    copyTextToClipboard, mergeVenues,
    setUniqueAttractionAttribute,
    setUniqueEventAttribute,
    setUniqueVenueAttribute,
    supportedLanguages,
    toastSuccess
} from "../../components/common/utilities";
import {ArrowLongLeftIcon, ArrowLongRightIcon, ChevronDoubleLeftIcon} from "@heroicons/react/16/solid";
import NLPPrompt from "../../pages/nlp/nlpprompt";
import '../../redactor-4-1-6/redactor.min.css';
import Redactor from '../../redactor-4-1-6/redactor.usm.min.js';


function classNames(...classes: any[])
{
    return classes.filter(Boolean).join(' ')
}

export default function EditDescriptions({theData, artist,venue,event}) {
    const [venueList, setVenueList] = useState<any[]>([])
    const location = useLocation();
    const [searchingVenue, setSearchingVenue] = useState(false);
    const [venueName, setVenueName] = useState('');
    const [descriptions, setDescriptions] = useState([]);
    const [nextOffset, setNextOffset] = useState("");
    const [previousOffset, setPreviousOffset] = useState("");
    const [cancel, setCancel] = useState(null);
    const [NLPStatus, setNLPStatus] = useState([]);
    const [NLPUrl, setNLPUrl] = useState([]);
    const [NLPLangUrl, setNLPLangUrl] = useState([]);
    const [NLPData, setNLPData] = useState<SchemaEvent>();
    const [NLPDataLang, setNLPDataLang] = useState("");
    const [translation, setTranslation] = useState("");
    const [translationURL, setTranslationURL] = useState("");
    const [loading, setLoading] = useState(false);
    const [notJson, setNotJson] = useState(false);
    const [failedResponse, setFailedResponse] = useState("");
    const [isEvent, setIsEvent] = useState(false);
    const [isVenue, setIsVenue] = useState(false);
    const [isAttraction, setIsAttraction] = useState(false);
    const [system, setSystem] = useState("");
    const [assistant, setAssistant] = useState("");
    const [prompt, setPrompt] = useState("");
    const [showPrompt, setShowPrompt] = useState(false);
    const [titleEn, setTitleEn] = useState("");

    type SchemaEvent = {
        [key: string]: any; // ?? variable key
        name: string;
    };
    type SchemaLocation = {
        [key: string]: any; // ?? variable key
        name: string;
    };

    const loaderdata = useLoaderData() as any;


    useEffect(() => {

        if(theData['@type'] == 'Event')
        {
            setIsEvent(true);
            setSystem('I am a website for a music festival.');
            let assistantString = 'I need a description for an event.  The description should be returned in a SchemaEvent format in a JSON document only. The description should use appropriate HTML tags.';
            assistantString = assistantString + ' The description should be translated into Polish.';
            setAssistant(assistantString);
            let promptstring = 'The event is called '+theData.name+'.';
            if(theData.description)
            {
                promptstring = promptstring+' The event  has this description: '+theData.description;
            }

            setPrompt(promptstring);
            getDescriptions(theData['@id'],null,null);

        }
        else if(theData['@type'] == 'Place')
        {
            setIsVenue(true);
            setSystem('I am a website for a music festival.');
            setAssistant('I need a description for a venue.  The description should be returned in a SchemaPlace format in a JSON document only. The description should use appropriate HTML tags.');
            setPrompt('The Venue is called '+theData.name);
            if(theData.description)
            {
                setPrompt('The venue is called '+theData.name+ " and has this description: "+theData.description);
            }
            getDescriptions(null,null,theData['@id']);

        }
        else
        {
            setIsAttraction(true);
            setSystem('I am a website for a music festival.');
            setAssistant('I need a description for an artist.  The description should be returned in a SchemaArtist format in a JSON document only. The description should use appropriate HTML tags.');
            setPrompt('The artist is called '+theData.name);
            if(theData.description)
            {
                setPrompt('The artist is called '+theData.name+ " and has this description: "+theData.description);
            }
            getDescriptions(null,theData['@id'],null);
            setRedactors();

        }


    }, []);

    //console.log('theData is:',theData);
    let aieditor = Redactor('#aieditor');
    let descriptioneditor = Redactor('#description-html');
    let descriptioneneditor = Redactor('#description-html-en');
    let descriptioniseditor = Redactor('#description-html-is');
    let descriptionpleditor = Redactor('#description-html-pl');
    let descriptiondaeditor = Redactor('#description-html-da');
    let descriptionnoeditor = Redactor('#description-html-no');
    let descriptionseeditor = Redactor('#description-html-se');

    const setRedactors = () => {
        descriptioneditor = Redactor('#description-html');
        descriptioneneditor = Redactor('#description-html-en');
        descriptioniseditor = Redactor('#description-html-is');
        descriptionpleditor = Redactor('#description-html-pl');
        descriptiondaeditor = Redactor('#description-html-da');
        descriptionnoeditor = Redactor('#description-html-no');
        descriptionseeditor = Redactor('#description-html-se');
    }



    const getNLPLang = (url): any => {
        axios.get(url).then(function (response) {
            // handle success
            //console.log("NLPLang", response.data);
            if (response.data.status)
            {
                setNLPStatus(response.data.status);
            }
            if (response.data.status === 'SUCCESS' && response.data.result)
            {
                //setLoading(false);

                //editor = Redactor('#aieditor');

                setNLPDataLang(response.data.result);

            }
            else if (response.data.status === 'FAILURE')
            {

            }
            else
            {
                //setLoading(true);
                pollNLPLang(url);
            }

        });

    }

    const [count, setCount] = useState(0);



    const pollNLPLang = (url) => {
        //setCount(count + 1);
        setTimeout(() => getNLPLang(url), 5000)
    }

    const getTranslation = (url): any => {
        axios.get(url).then(function (response) {
            // handle success
            //console.log("NLPLang", response.data);
            if (response.data.status)
            {
                setNLPStatus(response.data.status);
            }
            if (response.data.status === 'SUCCESS' && response.data.result)
            {
                //setLoading(false);

                //editor = Redactor('#aieditor');

                setTranslation(response.data.result.translation);


            }
            else if (response.data.status === 'FAILURE')
            {

            }
            else
            {
                //setLoading(true);
                pollTranslation(url);
            }

        });

    }


    const pollTranslation = (url) => {
        //setCount(count + 1);
        setTimeout(() => getTranslation(url), 5000)
    }


    function getDescriptions(eventid,artistid,venueid)
    {
            setSearchingVenue(true);
            let postData = {
                ticket: localStorage.getItem("ticket"),
            };
            if(eventid)
            {
                console.log('eventid',eventid);
                postData['event'] = eventid;

            }
            else if(artistid)
            {
                console.log('artistid',artistid);
                postData['artist'] = artistid;
            }
            else if (venueid)
            {
                console.log('venueid',venueid);
                postData['venue'] = venueid;
            }
            axios.post(`${process.env.REACT_APP_API_URL}/p/manage/event/descriptions.do`, postData,{
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            })
                .then(function (response) {
                    // handle success
                    //console.log(response);
                    let location = response.data;
                    //console.log(location);
                    setSearchingVenue(false);
                    setDescriptions(location);
                    populateDescriptions(location);

                    return location;

                })
                .catch(function (error) {
                    // handle error
                    console.log(error);
                    return error;
                })


    }

    const populateDescriptions = (thedescriptions) => {
        if(thedescriptions.length > 0)
        {
            thedescriptions.map((description, index) => {
                if(description.key == 'description-html')
                {
                    console.info("found description-html");
                    if(descriptioneditor && descriptioneditor.editor)
                    {
                        descriptioneditor.editor.setContent({html: description.value});
                    }
                    else {
                        descriptioneditor = Redactor('#description-html');
                        descriptioneditor.editor.setContent({html: description.value});
                    }
                   checkLanguage(description.value);
                }
                else if(description.key == 'description-html-en')
                {
                    if(descriptioneneditor && descriptioneneditor.editor)
                    {
                        descriptioneneditor.editor.setContent({html: description.value});
                    }
                    else {
                        descriptioneneditor = Redactor('#description-html-en');
                        descriptioneneditor.editor.setContent({html: description.value});
                    }
                }
                else if(description.key == 'description-html-is')
                {
                    if(descriptioniseditor && descriptioniseditor.editor)
                    {
                        descriptioniseditor.editor.setContent({html: description.value});
                    }
                    else {
                        descriptioniseditor = Redactor('#description-html-is');
                        descriptioniseditor.editor.setContent({html: description.value});
                    }
                }
                else if(description.key == 'description-html-pl')
                {
                    if(descriptionpleditor && descriptionpleditor.editor)
                    {
                        descriptionpleditor.editor.setContent({html: description.value});
                    }
                    else {
                        descriptionpleditor = Redactor('#description-html-pl');
                        descriptionpleditor.editor.setContent({html: description.value});
                    }
                }
                else if(description.key == 'description-html-da')
                {
                    if(descriptiondaeditor && descriptiondaeditor.editor)
                    {
                        descriptiondaeditor.editor.setContent({html: description.value});
                    }
                    else {
                        descriptiondaeditor = Redactor('#description-html-da');
                        descriptiondaeditor.editor.setContent({html: description.value});
                    }
                }
                else if(description.key == 'description-html-no')
                {
                    if(descriptionnoeditor && descriptionnoeditor.editor)
                    {
                        descriptionnoeditor.editor.setContent({html: description.value});
                    }
                    else {
                        descriptionnoeditor = Redactor('#description-html-no');
                        descriptionnoeditor.editor.setContent({html: description.value});
                    }
                }
                else if(description.key == 'description-html-se')
                {
                    if(descriptionseeditor && descriptionseeditor.editor)
                    {
                        descriptionseeditor.editor.setContent({html: description.value});
                    }
                    else {
                        descriptionseeditor = Redactor('#description-html-se');
                        descriptionseeditor.editor.setContent({html: description.value});
                    }
                }
                else if(description.key == 'title-en')
                {
                    setTitleEn(description.value);


                }
            })
        }
    }

    const checkLanguage = (text) => {
        axios.post(`https://translator.promogogo.com/nlp/lang`, {
            text: text
        }, {
                       headers: {
                           'instance': loaderdata.instance, 'face-uri': loaderdata.url,
                       },
                   }).then(function (response) {
            // handle success
            //console.log("Lang response", response.data);
            if (response.data.url)
            {
                setNLPLangUrl(response.data.url);
                //localStorage.setItem('nlpprompturl', response.data.url);
                getNLPLang(response.data.url);
            }


        }).catch(function (error) {
            // handle error
            console.log(error);

        });
    }

    const translateText = (text,language) => {
        axios.post(`https://translator.promogogo.com/nlp/translate/`+language, {
            text: text
        }, {
                       headers: {
                           'instance': loaderdata.instance, 'face-uri': loaderdata.url,
                       },
                   }).then(function (response) {
            // handle success
            //console.log("Lang response", response.data);
            if (response.data.url)
            {
                setTranslationURL(response.data.url);
                //localStorage.setItem('nlpprompturl', response.data.url);
                getTranslation(response.data.url);
            }


        }).catch(function (error) {
            // handle error
            console.log(error);

        });
    }




    const setDescription = (e,key) => {
        let html = "";
        if(key == 'description-html')
        {
            html = descriptioneditor.editor.getContent();
        }
        else if(key == 'description-html-en')
        {
           html = descriptioneneditor.editor.getContent();
        }
        else if(key == 'description-html-is')
        {
            html = descriptioniseditor.editor.getContent();
        }
        else if(key == 'description-html-pl')
        {
            html = descriptionpleditor.editor.getContent();
        }
        else if(key == 'description-html-no')
        {
            html = descriptionnoeditor.editor.getContent();
        }
        else if(key == 'description-html-da')
        {
            html = descriptiondaeditor.editor.getContent();
        }
        else if(key == 'description-html-se')
        {
            html = descriptionseeditor.editor.getContent();
        }
        else if(key == 'title-en')
        {
            html = document.getElementById('title-en').getAttribute('value');
        }

        console.log(html);
        let value = html;
        let unique = true;
        let remove = false;
        if(isEvent)
        {
            let eventid = theData['@id'];

            setUniqueEventAttribute(key, value, unique, remove, eventid);
            toastSuccess('Event Updated');

        }
        else if(isAttraction)
        {
            let artistid = theData['@id'];
            setUniqueAttractionAttribute(key, value, unique, remove, artistid);
            toastSuccess('Attraction Updated');

        }

        else if(isVenue)
        {
            let artistid = theData['@id'];
            setUniqueVenueAttribute(key, value, unique, remove, artistid);
            toastSuccess('Venue Updated');

        }


    }


    return (

        <div className="min-h-full">

            <div className="bg-white ">

                <div className="mx-auto mt-6 max-w-2xl leading-8">
                    <button className={'relative -ml-px inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10'} onClick={() => setShowPrompt(!showPrompt)}>{!showPrompt && <span>Get </span>}{showPrompt && <span>Hide </span>}AI Help</button>
                    {showPrompt && <NLPPrompt theData={theData}/>}

                    <div className="bg-white border-b border-gray-200">
                        <div className="p-4">
                            <div className="text-lg font-bold">Default</div>
                            <div className="text-sm text-gray-500">The text we display if there is no language specific
                                text.
                            </div>
                            <textarea id={'description-html'}></textarea>
                            <div className={'text-sm text-gray-500'}>Language: {NLPDataLang.toUpperCase()}</div>
                            <button
                                className={'relative -ml-px inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10'}
                                onClick={(e) => setDescription(e, 'description-html')}>Save
                            </button>
                            <span className="isolate inline-flex rounded-md shadow-sm">
      <button
          onClick={(e) => translateText(descriptioneditor.editor.getContent(), 'en')}

          type="button"
          className="relative inline-flex items-center rounded-l-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10"
      >
        Translate EN
      </button>
      <button
          onClick={(e) => translateText(descriptioneditor.editor.getContent(), 'is')}

          type="button"
          className="relative -ml-px inline-flex items-center bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10"
      >
        IS
      </button>
                                <button
                                    onClick={(e) => translateText(descriptioneditor.editor.getContent(), 'da')}
                                    type="button"
                                    className="relative -ml-px inline-flex items-center bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10"
                                >
        DA
      </button>
                                <button
                                    onClick={(e) => translateText(descriptioneditor.editor.getContent(), 'no')}

                                    type="button"
                                    className="relative -ml-px inline-flex items-center bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10"
                                >
        NO
      </button>
                                <button
                                    onClick={(e) => translateText(descriptioneditor.editor.getContent(), 'se')}

                                    type="button"
                                    className="relative -ml-px inline-flex items-center bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10"
                                >
        SE
      </button>
      <button
          onClick={(e) => translateText(descriptioneditor.editor.getContent(), 'pl')}

          type="button"
          className="relative -ml-px inline-flex items-center rounded-r-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10"
      >
        PL
      </button>
    </span>
                        </div>
                        {translation && <div className="p-4" dangerouslySetInnerHTML={{__html:translation}} onClick={() => copyTextToClipboard(translation)}></div>}
                    </div>
                    <div className="bg-white border-b border-gray-200 p-2">
                        <div className="text-lg font-bold">Localizations:</div>

                    </div>
                    <div key={'english-title'} className="bg-white border-b border-gray-200">
                        <div className="p-4">
                            <div className="text-lg font-bold">English title (en)</div>
                            <div className="text-sm text-gray-500"></div>
                            <input id={'title-en'} defaultValue={titleEn}></input>
                            <button
                                className={'relative -ml-px inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10'}
                                onClick={(e) => setDescription(e,'title-en')}>Save</button>
                        </div>
                    </div>


                    {supportedLanguages.map((language: any, index: number) => (
                        <div key={index} className="bg-white border-b border-gray-200">
                            <div className="p-4">
                                <div className="text-lg font-bold">{language.name} ({language.code})</div>
                                <div className="text-sm text-gray-500"></div>
                                <textarea id={'description-html-' + language.code}></textarea>
                                <button
                                    className={'relative -ml-px inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10'}
                                    onClick={(e) => setDescription(e,'description-html-'+language.code)}>Save</button>
                            </div>
                        </div>))}
                </div>

            </div>

        </div>)
}
